import { StoreOptions, Store } from 'vuex';
import * as actions from './actions';

export default {
  actions,
} as StoreOptions<any>;
